export const parseDateStringToUTCString = (dateString: string) => dateString.replace(" ", "T") + "Z"
